import { RegisterSuccess as RegisterSuccessPage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/register/success")({
  component: RegisterSuccessPage,
  beforeLoad: () => {
    document.title = "Maifud - Registro Exitoso";
  },
});
